import UnitsTable from './UnitsTable';

export default UnitsTable;
